import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { ReviewsEntityState } from './reviews.entity.reducer';
import { reviewsEntitySelectorKey } from './reviews.entity.reducer';

export const reviewEntityState = createFeatureSelector<ReviewsEntityState>(
  reviewsEntitySelectorKey
);

export const selectReviewsWithStatistics = createSelector(
  reviewEntityState,
  (state) => state.getReviews.data
);

export const selectSingleReview = createSelector(
  reviewEntityState,
  (state) => state.getReviews.data?.reviews?.[0]
);

export const selectReviewStatistics = createSelector(
  reviewEntityState,
  (state) => state.getReviewStatistics.data
);
